import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";

interface IMainContentProps {
    WithPaper?: boolean;
}

const useStyles = makeStyles({
    root: {
        minHeight: "calc(100vh - 200px)",
        marginBottom: 60
    }
});

export const _MainContent: React.FC<IMainContentProps> = props => {
    const classes = useStyles();

    return props.WithPaper ? (
        <Card elevation={1} className={classes.root}>
            <CardContent>{props.children}</CardContent>
        </Card>
    ) : (
        <div className={classes.root}>{props.children}</div>
    );
};

_MainContent.defaultProps = {
    WithPaper: true
};



// WEBPACK FOOTER //
// ./src/inar2/layout/MainContent.tsx